import { DetailedUser } from '@mews-commander/data-access';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Stack, Typography } from '@optimus-web/core';
import { ActivityMetaData } from './ActivityMetaData';
import { UserAuthorizedDevices } from './UserAuthorizedDevices';

interface UserDetailContentActivityProps {
    user: DetailedUser;
}

export function UserDetailContentActivity({ user }: UserDetailContentActivityProps) {
    const hasActivityDevices = user?.userDevices && user?.userDevices.length > 0;

    return (
        <Stack vertical spacing="400">
            <Section title={TextKey.Activity}>
                <ActivityMetaData user={user} />
            </Section>

            {hasActivityDevices && (
                <Section title={TextKey.AuthorizedDevicesSectionTitle}>
                    <UserAuthorizedDevices user={user} />
                </Section>
            )}
        </Stack>
    );
}

function Section({ title, children }: { title: Mews.TextKey; children: React.ReactNode }) {
    return (
        <Stack vertical spacing="200">
            <Typography textStyle="titleMediumStrong" as="h3">
                <LocalizedText textKey={title} />
            </Typography>
            <Stack vertical>{children}</Stack>
        </Stack>
    );
}
